import React from "react";
import AsyncSelect from "react-select/async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFilter, faPlay, faSlidersH, faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import styles from "../SideMenu.css";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { getUserType } from "../utils/index";
import Accordion from "react-bootstrap/Accordion";
import apiUrl from "../apiUrlConstant";
import InventoryByCity from "./charts/InventoryByCity";

import SummaryInventoryByCity from "./charts/SummaryInventoryByCity";
import WeightedAvg from "./charts/SummaryWeightedAvg";
import LeasedAreaYearWise from "./charts/LeasedAreaYearWise";
import SummaryAreaLeased from "./charts/SummaryAreaLeased";
import SummaryAssetWiseAreaExpiry from "./charts/SummaryAssetWiseAreaExpiry";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import InventoryByOwners from "./charts/InventoryByOwners";
import TransactionSizeWiseShare from "./charts/TransactionSizeWiseShare";
import LeasingInventory from "./charts/LeasingInventory";
import RentalYearWiseSummary from "./charts/RentalYearWiseSummary"
import CompanyPerformance from "./charts/CompanyPerformance";
import OverviewComponent from "./charts/overviewComponent"
import { JsonToExcel } from "react-json-to-excel";
import Dropdown from "react-bootstrap/Dropdown";
var revenueReportText = "Revenue Report";

if (getUserType() == "Occupier" || getUserType() == "occupier") {
  revenueReportText = "Expense Report";
}
let options = [
  { label: 1, value: "one" },
  { label: 2, value: "two" },
];

let LeaseStatus = [
  //{ label: 'ALL', value: 'ALL'  },
  { label: "Active", value: "2" },
  { label: "Expired", value: "3" },
  { label: "Terminated", value: "4" },
];
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class DashboardIndex extends React.Component {
  state = {
    openMenu: [""],
    activeKey: "1-1",
    summaryData: {},
    analysisData: {},
    showFilter: false,
    assetList: [],
    occupierList: [],
    searchTerm: "",
    counter: Math.random(),
    tableAssetData: [],
    occupierVal: "",
    assetVal: "",
    leaseStatus: "",
    forceReset: Math.random(),
  };

  constructor(props) {
    super(props);
  }

  handleOccupierChange = (newValue) => {
    this.setState({ occupierVal: newValue.value }, () => {
      this.fetchAssetDetails("");
      this.fetchAssetSummary("");
      this.fetchTableAssetDetails("");
      this.setState({ counter: Math.random() });
    });
  };

  handleStatusChange = (newValue) => {
    this.setState({ leaseStatus: newValue.value }, () => {
      this.fetchAssetDetails("");
      this.fetchAssetSummary("");
      this.fetchTableAssetDetails("");
      this.setState({ counter: Math.random() });
    });
  };

  handleMainChange = (newValue) => {
    this.setState({ searchTerm: newValue.value }, () => {
      this.fetchAssetDetails("");
      this.fetchAssetSummary("");
      this.fetchTableAssetDetails("");
      this.setState({ counter: Math.random() });
    });
  };

  handleInputChange = (newValue) => {
    this.setState({ assetVal: newValue.value }, () => {
      this.fetchAssetDetails("");
      this.fetchAssetSummary("");
      this.fetchTableAssetDetails("");
      this.setState({ counter: Math.random() });
    });
  };

  filterColors = (inputValue) => {
    return this.state.assetList.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  loadOptions = (inputValue, callback) => {
    setTimeout(() => {
      callback(this.filterColors(inputValue));
    }, 1000);
  };

  fetchAssetDetails = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/dashboard/fetch-asset-summary-details?search=` +
      this.state.searchTerm + `&occupier=${this.state.occupierVal}&leaseStatus=${this.state.leaseStatus}&assetVal=${this.state.assetVal}`, { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ summaryData: data });
      });
  };

  fetchTableAssetDetails = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/dashboard/asset-rental-details?search=` +
      this.state.searchTerm +
      `&assetVal=${this.state.assetVal}&occupier=${this.state.occupierVal}&leaseStatus=${this.state.leaseStatus}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("fetchTableAssetDetails", data);
        this.setState({ tableAssetData: data });
      });
  };

  fetchAssetSummary = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/dashboard/fetch-asset-analysis-details?search=` +
      this.state.assetVal +
      `&occupier=${this.state.occupierVal}&leaseStatus=${this.state.leaseStatus}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ analysisData: data });
      });
  };

  componentDidMount() {
    this.fetchAssetDetails("");
    this.fetchAssetSummary("");
    this.fetchTableAssetDetails("");

    fetch(`${apiUrl.apiUrl.url}/asset/fetch-all-assets`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        var assetList = [{ label: "ALL", value: "" }];
        data.forEach(function (arrayItem) {
          assetList.push({
            label: arrayItem.asset_name,
            value: arrayItem.id,
          });
        });
        this.setState({ assetList: assetList });
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        var occupierList = [];
        data["occupierList"].forEach(function (arrayItem) {
          occupierList.push({
            label: arrayItem.text,
            value: arrayItem.id,
          });
        });
        this.setState({ occupierList: occupierList });
      });
  }

  render() {
    let url = this.props.match;
    console.log(this.props.location.pathname);
    return (
      <div className="parentContainer">
        <div className="tabsWithFilterBtn">
          <span
            className="filterOuterBox"
            onClick={(e) => {
              this.setState({ showFilter: !this.state.showFilter });
            }}
          >
            <FontAwesomeIcon icon={faFilter} /> Filter
          </span>
          {this.state.showFilter ? <FontAwesomeIcon className="faplayButton" icon={faPlay} /> : ""}
          {this.state.showFilter && (
            <div className="filterMenuMain">
              <div className="filterMenuMainParent">
                <div className="filterMenuMainInner">
                  <AsyncSelect
                    key={this.state.forceReset}
                    className="dashboard-search w-100"
                    classNamePrefix="dashboard-search-inner"
                    defaultOptions={this.state.assetList}
                    loadOptions={this.loadOptions}
                    onChange={(e) => {
                      this.handleInputChange(e);
                    }}
                    placeholder={<p className="m-0 placeholderText">Select Asset</p>}
                  />
                </div>
                <div className="filterMenuMainInner">
                  <AsyncSelect
                    key={this.state.forceReset}
                    className="dashboard-search w-100"
                    classNamePrefix="dashboard-search-inner"
                    defaultOptions={this.state.occupierList}
                    loadOptions={this.loadOptions}
                    onChange={(e) => {
                      this.handleOccupierChange(e);
                    }}
                    placeholder={<p className="m-0 placeholderText">Select Occupier</p>}
                  />
                </div>
                <div className="filterMenuMainInner">
                  <AsyncSelect
                    key={this.state.forceReset}
                    className="dashboard-search w-100"
                    classNamePrefix="dashboard-search-inner"
                    defaultOptions={LeaseStatus}
                    loadOptions={this.loadOptions}
                    onChange={(e) => {
                      this.handleStatusChange(e);
                    }}
                    placeholder={<p className="m-0 placeholderText">Select Status</p>}
                  />
                </div>
                <div className="filterMenuMainInner">
                  <button class="resetBtn"
                    onClick={(e) => {
                      this.setState({
                        forceReset: Math.random(),
                        occupierVal: "",
                        leaseStatus: "",
                        assetVal: "",
                        counter: Math.random(),
                      }, function () {
                        this.fetchAssetDetails("");
                        this.fetchAssetSummary("");
                        this.fetchTableAssetDetails("");
                      });
                    }}>
                    <img src="/images/icons/reset.svg" alt="Reset Filters" />
                  </button>
                  <FontAwesomeIcon
                    onClick={(e) => {
                      this.setState({ showFilter: false });
                    }}
                    icon={faTimesCircle}
                    className="closeButton"
                  />
                </div>
              </div>
            </div>
          )}
          <Tabs
            defaultActiveKey="1"
            id="uncontrolled-tab-example"
            className="customNavTabsDesign"
          >
            <Tab eventKey="1" title="Summary">
              <div className="accordianBodyBox">
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10"><em className="iconWithBg"><img src="/images/icons/assets.svg" alt="Assets" /></em> <span>Assets</span></h4>
                  <h2>{this.state.summaryData.assetResult != undefined
                    ? this.state.summaryData.assetResult.total
                    : "-"}{" "}</h2>
                  <hr />
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Ready</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.assetResult != undefined
                        ? this.state.summaryData.assetResult["ready"]
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Under Construction</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.assetResult != undefined
                        ? this.state.summaryData.assetResult["uc"]
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                    <em className="iconWithBg"><img src="/images/icons/inventory.svg" alt="Inventory" /></em>
                    <span>
                      Inventory
                    </span>
                    {/* <span>Total Units</span> */}
                  </h4>
                  <h2>{this.state.summaryData.inventoryResult != undefined
                    ? this.state.summaryData.inventoryResult.total
                    : "-"}</h2>
                  <hr />
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Occupied</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.inventoryResult != undefined
                        ? this.state.summaryData.inventoryResult.Leased
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Owner Occupied</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.inventoryResult != undefined
                        ? this.state.summaryData.inventoryResult[
                        "Owner Occupied"
                        ]
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Vacant</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.inventoryResult != undefined
                        ? this.state.summaryData.inventoryResult["Vacant"]
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                    <em className="iconWithBg"><img src="/images/icons/lease_expire.svg" alt="lease_expire" /></em>
                    <span>Lease Expiring In 24 Months</span>
                  </h4>
                  <h2>{this.state.summaryData.leaseResult != undefined
                    ? this.state.summaryData.leaseResult.total
                    : "-"}
                    <span style={{ fontSize: "12px", paddingLeft: "5px" }}>
                      sqft
                    </span>
                  </h2>
                  <hr />
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Next 6 Month</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.leaseResult != undefined
                        ? this.state.summaryData.leaseResult["6_month"] +
                        "   sqft  "
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>6 - 12 Month</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.leaseResult != undefined
                        ? this.state.summaryData.leaseResult["12_month"] +
                        "   sqft  "
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>12 - 24 Month</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.leaseResult != undefined
                        ? this.state.summaryData.leaseResult["24_month"] +
                        "   sqft  "
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                    <em className="iconWithBg"><img src="/images/icons/rupee.svg" alt="rupee" /></em>
                    <span>Monthly Rental</span></h4>
                  <h2>
                    {this.state.summaryData.rentalResult != undefined
                      ? this.state.summaryData.rentalResult.total
                      : "-"}
                    <span style={{ fontSize: "12px", paddingLeft: "5px" }}>
                      Cr
                    </span>
                  </h2>
                  <hr />
                </div>
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                    <em className="iconWithBg"><img src="/images/icons/active.svg" alt="active" /></em><span>Active Occupiers</span></h4>
                  <h2>{this.state.summaryData.occupierResult != undefined
                    ? this.state.summaryData.occupierResult.total
                    : "-"}{" "}</h2>
                  <hr />
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Leased to new Occupiers</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.occupierResult != undefined
                        ? this.state.summaryData.occupierResult["new"]
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Existing Occupiers</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.occupierResult != undefined
                        ? this.state.summaryData.occupierResult["existing"]
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="container-fluid p-0">
                <div className="customHeightClassMain">
                  <div className="customHeightClass ps-0">
                    <div className="chartContainer">
                      <InventoryByCity
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass pe-0">
                    <div className="chartContainer">
                      <InventoryByOwners
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass customMaxHeightForGraph ps-0">
                    <div className="chartContainer">
                      <TransactionSizeWiseShare
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass pe-0">
                    <div className="chartContainer">
                      <LeasingInventory
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  {/* <div className="customHeightClass pe-0 fullWidth">
                      <div className="chartContainer">
                        <RentalYearWiseSummary
                          key={this.state.counter}
                          searchTerm={this.state.searchTerm}
                          assetVal={this.state.assetVal}
                          leaseStatus={this.state.leaseStatus}
                          occupierVal={this.state.occupierVal}
                        />
                      </div>
                    </div> */}

                  <div className="customHeightClass fullWidth pe-0">
                    <div className="chartContainer">
                      {/* <CompanyPerformance /> */}
                      <CompanyPerformance
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass fullWidth pe-0">
                    <div className="chartContainer">
                      {/* <CompanyPerformance /> */}
                      <OverviewComponent
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="2" title="Asset Analysis">
              <div className="accordianBodyBox">
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                    <em className="iconWithBg"><img src="/images/icons/assets.svg" alt="assets" /></em>
                    <span>Assets</span></h4>
                  <h2>{this.state.summaryData.assetResult != undefined
                    ? this.state.summaryData.assetResult.total
                    : "-"}{" "}</h2>
                  <hr />
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Ready</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.assetResult != undefined
                        ? this.state.summaryData.assetResult["ready"]
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Under Construction</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.summaryData.assetResult != undefined
                        ? this.state.summaryData.assetResult["uc"]
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                  <em className="iconWithBg"><img src="/images/icons/inventory.svg" alt="inventory" /></em>
                    <span>Leased Area</span>
                  </h4>
                  <h2>{this.state.analysisData.areaLeased != undefined
                    ? this.state.analysisData.areaLeased.total
                    : "-"}
                    <span style={{ fontSize: "12px", paddingLeft: "5px" }}>
                      sqft
                    </span></h2>
                  <hr />
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>5 year CAGR</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.analysisData.areaLeased != undefined
                        ? this.state.analysisData.areaLeased.cagr
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Avg Annual Leasing</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.analysisData.areaLeased != undefined
                        ? this.state.analysisData.areaLeased["anual_leasing"]
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Leased to Top 10 Occupiers</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.analysisData.areaLeased != undefined
                        ? this.state.analysisData.areaLeased["top_occupiers"]
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="accordianBodyBoxInner">
                  <h4 className="dflexWitGap10">
                  <em className="iconWithBg"><img src="/images/createlease/1.svg" alt="lease_expire" /></em>
                    <span>Vacant</span></h4>
                  <h2>
                    {this.state.analysisData.vacantDetails != undefined
                      ? this.state.analysisData.vacantDetails.total
                      : "-"}
                    <span style={{ fontSize: "12px", paddingLeft: "5px" }}>
                      sqft
                    </span>
                  </h2>
                  <hr />
                  {/* <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Wt Avg Days Since Vacant</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.analysisData.vacantDetails != undefined
                        ? this.state.analysisData.vacantDetails[
                        "weightedAvg"
                        ] + "   Days  "
                        : "-"}
                    </p>
                  </div> */}
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Wt Avg Re-leasing Period</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.analysisData.vacantDetails != undefined
                        ? this.state.analysisData.vacantDetails["releasing_period"] +
                        " "
                        : ""}
                    </p>
                  </div>
                  <div className="d-flex align-items-center customGap justify-content-between mb-2">
                    <p>Wt Avg Re-leasing spread</p>
                    <p className="fw-500">
                      {" "}
                      {this.state.analysisData.vacantDetails != undefined
                        ? this.state.analysisData.vacantDetails["releasing_spread"] +
                        " "
                        : ""}
                    </p>
                  </div>
                </div>
                {/* <div className="accordianBodyBoxInner">
                    <h2>
                      {this.state.summaryData.rentalResult != undefined
                        ? this.state.summaryData.rentalResult.total
                        : "-"}
                      <span style={{ fontSize: "12px", paddingLeft: "5px" }}>
                      </span>
                      <br />
                      <span>Wt Avg psf Rent</span>
                    </h2>
                    <div className="d-flex align-items-center customGap justify-content-between mb-2">
                      <p>5 year CAGR</p>
                      <p className="fw-500">
                        {" "}
                        {this.state.summaryData.rentalResult != undefined
                          ? this.state.summaryData.rentalResult["5_year_cagr"]
                          : "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center customGap justify-content-between mb-2">
                      <p>Avg Annual Escalation</p>
                      <p className="fw-500">
                        {" "}
                        {this.state.summaryData.rentalResult != undefined
                          ? this.state.summaryData.rentalResult[
                              "annual_escaltion"
                            ]
                          : "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center customGap justify-content-between mb-2">
                      <p>Income from top 10 occupier</p>
                      <p className="fw-500">
                        {" "}
                        {this.state.summaryData.rentalResult != undefined
                          ? this.state.summaryData.rentalResult[
                              "income_from_top_occupier"
                            ]
                          : "-"}
                      </p>
                    </div>
                  </div> */}
                {/* <div className="accordianBodyBoxInner">
                    <h2>
                      {this.state.summaryData.occupierResult != undefined
                        ? this.state.summaryData.occupierResult.total
                        : "-"}{" "}
                      <span>months WALE</span>
                    </h2>
                    <div className="d-flex align-items-center customGap justify-content-between mb-2">
                      <p>Avg Portfolio WALE</p>
                      <p className="fw-500">
                        {" "}
                        {this.state.summaryData.occupierResult != undefined
                          ? this.state.summaryData.occupierResult["new"]
                          : "-"}
                      </p>
                    </div> */}
                {/* <div className="d-flex align-items-center customGap justify-content-between mb-2">
                      <p>Y-o-Y Change in WALE -</p>
                      <p className="fw-500">
                        {" "}
                        {this.state.summaryData.occupierResult != undefined
                          ? this.state.summaryData.occupierResult["existing"]
                          : "-"}
                      </p>
                    </div> */}
                {/* <div className="d-flex align-items-center customGap justify-content-between mb-2">
                      <p>AVG 5 year WALE</p>
                      <p className="fw-500">
                        {" "}
                        {this.state.summaryData.occupierResult != undefined
                          ? this.state.summaryData.occupierResult["existing"]
                          : "-"}
                      </p>
                    </div>
                  </div> */}
              </div>
              <div className="container-fluid p-0">
                <div className="customHeightClassMain">
                  <div className="customHeightClass fullWidth ps-0">
                    <div className="chartContainer">
                      <SummaryInventoryByCity
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass ps-0">
                    <div className="chartContainer">
                      <WeightedAvg
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass ps-0">
                    <div className="chartContainer">
                      <LeasedAreaYearWise
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass customMaxHeightForGraph ps-0">
                    <div className="chartContainer">
                      <SummaryAreaLeased
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="customHeightClass customMaxHeightForGraph pe-0">
                    <div className="chartContainer">
                      <SummaryAssetWiseAreaExpiry
                        key={this.state.counter}
                        searchTerm={this.state.searchTerm}
                        assetVal={this.state.assetVal}
                        leaseStatus={this.state.leaseStatus}
                        occupierVal={this.state.occupierVal}
                      />
                    </div>
                  </div>
                  <div className="fullWidth tableContainer p-0 m-0">
                    <div className="chartContainer">
                      <div className="row mb-3">
                        <div className="col-6">
                          <h4 className="mb-2">Asset Details</h4>
                        </div>
                        <div className="col-6">
                          <Dropdown style={{ float: "right" }}>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                              className="chartDownloadContainer"
                            ></Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item>
                                <JsonToExcel
                                  title="Download as Excel"
                                  data={this.state.tableAssetData}
                                  fileName="assetWaleDetails"
                                  btnClassName="graphExcelDownloadBtn"
                                />
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>

                      <table className="table assetSummary table-striped w-100 customTable tableSimple">
                        <thead>
                          <tr>
                            <th>Asset Name</th>
                            <th>Gross Leasable Area (Sqft)</th>
                            <th>Rental (Psf/m)</th>
                            <th>WALE (Months)</th>
                            {/* <th>day diff</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.tableAssetData.map((val) => {
                            return (
                              <tr>
                                <td>{val.asset_name}</td>
                                <td>{val.gla}</td>
                                <td>{val.rental}</td>
                                <td>{val.wale}</td>
                                {/* <td>{val.timeDiff}</td> */}
                              </tr>
                            );
                          })}
                          {/* <tr>
                              <td>1</td>
                              <td>2</td>
                              <td>3</td>
                              <td>4</td>
                            </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        {/* <div className="row ms-0 mb-0 me-0 mt-3 dashboardMainHead position-relative">
          <div className="col-lg-5 p-0 dashboardMainHeadL">
            <div className="d-flex align-items-center customGap justify-content-between mb-2">
              <AsyncSelect
                className="dashboard-search w-100"
                classNamePrefix="dashboard-search-inner"
                defaultOptions={this.state.assetList}
                loadOptions={this.loadOptions}
                onChange={(e) => {
                  this.handleMainChange(e);
                }}
                placeholder={<p className="m-0 placeholderText">Select Asset</p>}
              // menuIsOpen= {true}
              />
              <span
                className="filterOuterBox"
                onClick={(e) => {
                  this.setState({ showFilter: !this.state.showFilter });
                }}
              >
                <FontAwesomeIcon icon={faSlidersH} />
              </span>
            </div>
          </div>
          <div className="col-lg-7 p-0 text-end dashboardMainHeadR">
            <div className="fontOuter minContent">
            </div>
          </div>

        </div> */}

      </div>
    );
  }
}

export default withRouter(DashboardIndex);
